import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getFleetManagerDocumentRequirements = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fleet-manager`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager document requirements fetch error:", error);
    throw error;
  }
};

const createFleetManagerDocumentRequirement = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fleet-manager`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager document requirement create error:", error);
    throw error;
  }
};

const getFleetManagerDocumentRequirementById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fleet-manager&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager document requirement fetch error:", error);
    throw error;
  }
};

const updateFleetManagerDocumentRequirement = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fleet-manager&id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager document requirement update error:", error);
    throw error;
  }
};

const deleteFleetManagerDocumentRequirement = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/document-requirements/?scope=fleet-manager&id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fleet manager document requirement delete error:", error);
    throw error;
  }
};

export {
  getFleetManagerDocumentRequirements,
  createFleetManagerDocumentRequirement,
  getFleetManagerDocumentRequirementById,
  updateFleetManagerDocumentRequirement,
  deleteFleetManagerDocumentRequirement,
};
